import React, { useState, useEffect } from 'react';
import { useAdmin } from "../../context/contextAdmin";

const AdminEmailDispatcher = () => {
  const {
    receiptEmail,
    setReceiptEmail,
    getReceiptEmail,
    loadingReceiptEmail
  } = useAdmin();
  const [status, setStatus] = useState({ type: '', message: '' });

  useEffect(() => {
    document.body.style.backgroundImage = "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.minHeight = "100vh";
    document.body.style.margin = "0";
  }, []);

  const handleSendInvite = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });

    try {
      const response = await getReceiptEmail(receiptEmail);
      if (response.success) {
        setStatus({ type: 'success', message: response.message });
        setReceiptEmail('');
      }
    } catch (err) {
      setStatus({ type: 'danger', message: err.message });
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
      <div
        className="card border-0 shadow-lg p-4 p-sm-5 text-center w-100"
        style={{ maxWidth: '450px', borderRadius: '24px', backgroundColor: '#ffffff' }}
      >
        {/* Admin Badge */}
        <div className="d-inline-flex align-items-center mx-auto mb-4 px-3 py-1 rounded-pill"
          style={{ backgroundColor: '#fef2f2', border: '1px solid #fee2e2', color: '#991b1b', fontSize: '12px', fontWeight: '700' }}>
          <span className="rounded-circle me-2" style={{ width: '8px', height: '8px', backgroundColor: '#ef4444' }}></span>
          ADMIN CONSOLE
        </div>

        <h1 className="fs-3 fw-bold mb-2 text-dark">Send Invitation</h1>
        <p className="text-muted small mb-4">
          Enter the recipient's receiptEmail to send the automated SAVE Security trial invitation.
        </p>

        <form onSubmit={handleSendInvite}>
          <div className="text-start mb-4">
            <label className="form-label small fw-bold text-secondary">Recipient Email Address</label>
            <input
              type="email"
              className="form-control form-control-lg bg-light border-0"
              placeholder="name@company.com"
              value={receiptEmail || ''}
              onChange={(e) => setReceiptEmail(e.target.value)}
              required
            />
          </div>

          {status.message && (
            <div className={`alert alert-${status.type} py-2 small mb-4`} role="alert">
              {status.message}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-lg w-100 text-white fw-bold mb-3"
            style={{ backgroundColor: '#0095ff', borderRadius: '12px', border: 'none', padding: '12px' }}
            disabled={loadingReceiptEmail}
          >
            {loadingReceiptEmail ? 'Sending...' : 'Send Invite Link'}
          </button>
        </form>

        <div className="border-top pt-3 mt-2">
          <p className="text-muted" style={{ fontSize: '11px' }}>
            Internal Use Only • Unauthorized Access Prohibited
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminEmailDispatcher;